export const coresPrincipais = {
  nome: 'orange',
  geral: '#e87400',
  hover: '#d07000',
  focus: '#bd6600',
};

export const coresPlanoA = {
  nome: 'purple',
  geral: '#472779',
  hover: '#3B2166',
  focus: '#311B54',
};

export const coresSecundarias = {
  nome: 'gray',
  geral: '#383A35',
  hover: '#1C1C1C',
  focus: '#474A51',
};

export const coresSimulacao = {
  nome: 'gray',
  geral: '#097770',
  hover: '#a9c0a6',
  focus: '#474A51',
};

export const alteraCorSistema = (corGeral, corHover, corFocus) => {
  const r = document.querySelector(':root');
  r.style.setProperty('--primary-color', corGeral);
  r.style.setProperty('--primary-color-hover', corHover);
  r.style.setProperty('--primary-color-focus', corFocus);
};

export const alterarParaCoresSimulacao = () => {
  const r = document.querySelector(':root');

  r.style.setProperty('--primary-color', '#097770');
  r.style.setProperty('--primary-color-hover', '#a9c0a6');
  r.style.setProperty('--primary-color-focus', '#474A51');
};
